export default "__VITE_ASSET__CLbrb94Y__"